<div class="container">
    <div class="mapping">
        <div>
			<span class="pt-title">PT Image Mapping</span>
			<div class="nav-search-item">
				<a [routerLink]="['/home']" class="basic-search">Back to Search</a> <span class="hidden-sm hidden-md"> | </span> <a href="{{staffURL}}" class="basic-search hidden-sm hidden-md">Return to Staff Portal Home</a>
			</div>

			<!-- COPY IMAGE SUCCESS MESSAGE :BEGIN -->
			<div class="alert alert-success mt-20" *ngIf="copyImageSuccess !== null">
				<em class="fa fa-check-circle"></em> {{copyImageSuccess.noOfImages}} {{(copyImageSuccess.noOfImages == 1 ? 'image' : 'images')}} have been copied successfully to
				<a *ngFor="let mailingID of copyImageSuccess.mailingID; let last = last;" (click)="onApproveClick(mailingID)">
					{{mailingID}}
					<ng-container *ngIf="!last">, </ng-container>
				</a>. Approve to complete image mapping.
			</div>
			<!-- COPY IMAGE SUCCESS MESSAGE :END -->

			<!-- ADD EDIT DELETE SUCCESS MESSAGE :BEGIN -->
			<div class="alert alert-success mt-20" *ngIf="alertSuccessMessage !== null" innerHTML="{{alertSuccessMessage}}"></div>
			<!-- ADD EDIT DELETE SUCCESS MESSAGE :END -->

            <h3 class="title">Specimen-Based Images - Search Results</h3>
			<span id="mailing">Mailing {{mailingID}}</span>
			<a id="information" class="hidden-sm hidden-md" (click)="onClickAdd('')">Add Mailing Information</a>
        </div>
    </div>

    <div class="mapping-search">
        <div class="row">
            <div class="col-md-10">
				<div class="row">
					<div class="col-md-3 col-sm-6">
						<div class="form-group">
							<label class="label">Specimen</label>
							<select class="form-control" [(ngModel)]="selectedSpecimenValue" (change)="onSpecimenChange($event)">
								<option value="">All</option>
								<option *ngFor="let list of specimenList" value="{{list.specimenCode}}">{{list.specimenCode}}</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 col-sm-6">
						<div class="form-group">
							<label class="label">Product</label>
							<select class="form-control" [(ngModel)]="selectedProductValue" (change)="onProductChange($event)">
								<option value="">All</option>
								<option *ngFor="let list of productList" value="{{list.productCode}}">{{list.productCode}}</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 col-sm-6">
						<div class="form-group">
							<label class="label">Year:</label>
							<select class="form-control" [(ngModel)]="selectedYearValue" (change)="onYearChange($event)">
								<option value="">Select Year</option>
								<option *ngFor="let year of mailingYears" value="{{year.year}}">{{year.year}}</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 col-sm-6">
						<div class="form-group">
							<label class="label">Mapped Mailings</label>
							<select class="form-control" [(ngModel)]="selectedMappedMailingValue" (change)="onMappedMailingChage($event)">
								<option value="">Select Mailings</option>
								<option *ngFor="let list of mappedImages" value="{{list.mailingId}}">{{list.mailingId}}</option>
							</select>
						</div>
					</div>
				</div>
            </div>
            <div class="col-md-2 col-sm-12 text-right text-sm-center">
				<a class="reset-link" (click)="onClickReset()">Reset</a>
                <a class="copy-image hidden-sm hidden-md" *ngIf="isCopy" (click)="copyImage($event)"> <img alt="copy image" src="./assets/img/copy-file.png" /> Copy Image</a>
            </div>
        </div>
    </div>

	<table mat-table [dataSource]="dataSource" class="table table-striped" aria-describedby="table">
		<ng-container matColumnDef="specimenCode">
			<th id="specimen" mat-header-cell *matHeaderCellDef>Mailing Info or Specimen</th>
			<td mat-cell *matCellDef="let element">{{(element.specimenCode) ? element.specimenCode : mailingID}}</td>
		</ng-container>

		<ng-container matColumnDef="group">
			<th id="group" mat-header-cell *matHeaderCellDef>Group</th>
			<td mat-cell *matCellDef="let element">{{(element.group) ? element.group : ''}}</td>
		</ng-container>

		<ng-container matColumnDef="sequence">
			<th id="sequance" mat-header-cell *matHeaderCellDef>Sequence #</th>
			<td mat-cell *matCellDef="let element">{{(element.sequence) ? element.sequence : ''}}</td>
		</ng-container>

		<ng-container matColumnDef="thumbnailView">
			<th id="thumbnail" mat-header-cell *matHeaderCellDef>Thumbnail</th>
			<td mat-cell *matCellDef="let element"> <input type="checkbox" class="checkbox" [checked]="element.thumbnailView == 'Y'" disabled> </td>
		</ng-container>

		<ng-container matColumnDef="externalName">
			<th id="external-image" mat-header-cell *matHeaderCellDef>External Image Name</th>
			<td mat-cell *matCellDef="let element">{{(element.externalName) ? element.externalName : ''}}</td>
		</ng-container>

		<ng-container matColumnDef="name">
			<th id="image-source-name" mat-header-cell *matHeaderCellDef>Image Source Name</th>
			<td mat-cell *matCellDef="let element"><a class="image-name" (click)="openImageLightBox(element.name, element.imageNumber)">{{(element.name) ? element.name : ''}}</a></td>
		</ng-container>

		<ng-container matColumnDef="imageNumber">
			<th id="image" mat-header-cell *matHeaderCellDef>Image</th>
			<td mat-cell *matCellDef="let element">{{(element.imageNumber) ? element.imageNumber : ''}}</td>
		</ng-container>

		<ng-container matColumnDef="action">
			<th id="action" mat-header-cell *matHeaderCellDef>Action</th>
			<td mat-cell *matCellDef="let element">
				<a (click)="onClickAdd(element)" class="icon hidden-sm hidden-md" title="Add Image">
					<img alt="add" src="./assets/img/add.png" />
				</a>
				<a (click)="onClickEdit(element)" class="icon" [class.disabled]="!element.name" title="Edit Image Attributes">
					<img alt="edit" src="./assets/img/edit.png" *ngIf="element.name" />
					<img alt="edit" src="./assets/img/disable-edit.png" *ngIf="!element.name" />
				</a>
				<a (click)="onClickHistory(element)" class="icon" [class.disabled]="!element.name" title="View Image Log">
					<img alt="log" src="./assets/img/history-clock.png" *ngIf="element.name" />
					<img alt="log" src="./assets/img/disable-history-clock.png" *ngIf="!element.name" />
				</a>
				<a (click)="onClickDelete(element)" class="icon" [class.disabled]="!element.name" title="Remove Image">
					<img alt="remove" src="./assets/img/trash.png" *ngIf="element.name" />
					<img alt="remove" src="./assets/img/disable-trash.png" *ngIf="!element.name" />
				</a>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{ redRow : row.approveFlag === 'N' }"></tr>

		<ng-container matColumnDef="noRecord">
			<mat-footer-cell *matFooterCellDef colspan="10"> There are no search results found. Please modify your selection and try again. </mat-footer-cell>
		</ng-container>
		<mat-footer-row *matFooterRowDef="['noRecord']" [ngClass]="{'hide':!(isDataSourceBlack)}"></mat-footer-row>
	</table>

	<div class="relative-block" *ngIf="addedImageObject.approved_show">
		<div class="approve-block">
			<button type="button" class="approve-btn" (click)="onClickApprove()">Approve</button>
		</div>
	</div>

	<div [ngClass]="{'hidden-md' : isDataSourceBlack }">
		<mat-paginator
			style-paginator
			[showTotalPages]="showTotalPages"
			[length]="dataSource?.data?.length"
			[pageSize]="pageSize"
			[pageSizeOptions]="pageSizeOptions">
		</mat-paginator>
	</div>
</div>

<div #lightbox class="image-lightbox">
	<div class="image-lightbox-top-bar">
		<p class="image-lightbox-text-container desktop-only">
			<span class="image-lightbox-image-label">{{mailingID}}</span>
		</p>
		<div (click)="closeImageLightbox()" class="image-lightbox-exit-button">X</div>
	</div>
	<div class="image-lightbox-image-container">
		<img alt="image light box" src={{lightBoxImagePath}} class="image-lightbox-image">
	</div>
	<p class="image-lightbox-text-container mobile-only">
		<span class="image-lightbox-image-label">{{mailingID}}</span>
	</p>
</div>